import { useContext } from "react";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import { AuthContext } from "../../Context/AuthContext";

const fetchDriverAssignmentById = async (assignmentId, token) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_SERVER_URL}/packages/fetchDriverAssignment/${assignmentId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to fetch driver assignment");
    }

    return response.json();
  } catch (error) {
    throw new Error(error.message);
  }
};

const useFetchDriverAssignmentById = () => {
  const { token } = useContext(AuthContext);
  const { assignmentId } = useParams();

  return useQuery(["driverAssignment", assignmentId], () =>
    fetchDriverAssignmentById(assignmentId, token)
  );
};

export default useFetchDriverAssignmentById;
